import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFlex,[_c(VIcon,{staticClass:"pr-1",attrs:{"small":""}},[_vm._v("person")]),_vm._v(_vm._s(_vm.data))],1)}
var staticRenderFns = []

export { render, staticRenderFns }